export const lumCalc = (hex) => {

  const rgb = hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => "#" + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16));

  return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
};

// transformar cor hexadecimal pra rgb
export const gradColor = (hex) => {

  if(hex.length === 0) return "#ffffff";

  const rgb = hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => "#" + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16));

    function scaleColor(color, scale) {
      const [r, g, b] = color.match(/\d+/g).map(Number);
      return [Math.round(r * scale), Math.round(g * scale), Math.round(b * scale)];
    }

    function RGBToHex(r, g, b) {
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    const originalColor = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`; // laranja
    const _rgb = scaleColor(originalColor, 0.45); // rgb(128, 64, 0)

    return RGBToHex(..._rgb)
};